import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04327bf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "global-search-menu-topic" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-w-full tw-h-full tw-items-start tw-justify-start tw-p-[25px]"
}
const _hoisted_3 = { class: "global-search-menu-topic-empty-text" }
const _hoisted_4 = {
  key: 1,
  class: "tw-flex tw-w-full tw-h-full tw-items-center tw-justify-center tw-text-center tw-p-5"
}
const _hoisted_5 = { class: "global-search-menu-topic-empty-text" }
const _hoisted_6 = { class: "global-search-menu-topic-item-title" }
const _hoisted_7 = {
  key: 0,
  class: "global-search-menu-topic-item-content custom-global-skeleton"
}
const _hoisted_8 = {
  key: 1,
  class: "global-search-menu-topic-item-content"
}
const _hoisted_9 = {
  key: 0,
  class: "tw-flex tw-items-center"
}
const _hoisted_10 = { class: "global-search-menu-topic-item-not-found-text" }

import { computed, onMounted, ref, watch } from "vue";
import { getComponentUiText, searchKeyValue } from "@/utils/utilities";
import { routers, SEARCH_TYPE_ID } from "@/utils/constants";
import store from "@/store";
import {
  getExternalMembersOrg,
  getInternalMembersOrg,
  getOrgRoles,
} from "@/services/org";
import {
  getAllChecklist,
  getDetailFromCheckListId,
} from "@/services/assessment";
import type { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { TopicName } from "@/components/common/globalSearch/constants";

/** components */
import PageTopic from "@/components/common/globalSearch/menuSearch/pageTopic.vue";
import OrgTopic from "@/components/common/globalSearch/menuSearch/orgTopic.vue";
import RecommendTopic from "@/components/common/globalSearch/menuSearch/recommendTopic.vue";
import MemberTopic from "@/components/common/globalSearch/menuSearch/memberTopic.vue";
import RoleTopic from "@/components/common/globalSearch/menuSearch/roleTopic.vue";
import AssessmentTopic from "@/components/common/globalSearch/menuSearch/assessmentTopic.vue";
import ModalHoverSearchAssessment from "@/components/assessment/modalHoverSearchAssessment.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'menuTopic',
  props: {
    selectedFilterIds: {},
    searchKey: {},
    searching: {}
  },
  emits: ["on-select", "close-menu"],
  setup(__props: any, { emit }) {

const props = __props;





const listResentSearch = computed(() => {
  return store.getters["Assessment/getRecentSearch"](SEARCH_TYPE_ID.GLOB);
});

const updateCurrentValueSearchKey = (value: string) => {
  emit("on-select", value);
};

const dataQueryPage = [
  [
    {
      title: getComponentUiText("app-menu-home-1"),
      url: routers.dashboard,
      description: getComponentUiText(
        "app-menu-submenu-dashboard-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-home-1",
      ),
    },
  ],
  [
    {
      title: getComponentUiText("app-menu-submenu-assess-manage-assessments-1"),
      url: routers.assessCreate,
      description: getComponentUiText(
        "app-menu-submenu-assessments-create-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-mange-assessments-1",
      ),
    },
  ],
  [
    {
      title: getComponentUiText(
        "app-menu-submenu-assess-complete-assessments-1",
      ),
      url: routers.assessChecklist,
      description: getComponentUiText(
        "app-menu-submenu-assessments-input-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-complete-ssessments-1",
      ),
    },
  ],
  [
    {
      title: getComponentUiText("app-menu-submenu-assess-recommendations-1"),
      url: routers.assessRecommend,
      description: getComponentUiText(
        "app-menu-submenu-recommendation-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-recommendations-1",
      ),
    },
  ],
  [
    {
      title: getComponentUiText("app-menu-submenu-share-cyber-health-report-1"),
      url: routers.shareProfile,
      description: getComponentUiText(
        "app-menu-submenu-cyber-report-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-cyber-health-report-1",
      ),
    },
  ],
  [
    {
      title: getComponentUiText("app-menu-submenu-assess-vendor-assessments-1"),
      url: routers.assessVendor,
      description: getComponentUiText(
        "app-menu-submenu-assessments-vendor-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-vendor-assessments-1",
      ),
    },
  ],
  [
    {
      title: getComponentUiText("app-menu-submenu-scan-scanning-1"),
      url: routers.scanScanning,
      description: getComponentUiText(
        "app-menu-submenu-scanning-page-description-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-scanning-1",
      ),
    },
  ],

  [
    {
      title: getComponentUiText("app-menu-submenu-settings-setup-1"),
      url: routers.settingsSetup,
      description: getComponentUiText(
        "app-header-menu-search-page-description-settings-setup-1",
      ),
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-settings-setup-1",
      ),
    },

    {
      children: [
        {
          title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText(
            "app-menu-submenu-settings-org-1",
          )} > ${getComponentUiText(
            "app-menu-submenu-settings-org-details-1",
          )}`,
          url: routers.settingOrgDetails,
          descriptionInSearchModal: getComponentUiText(
            "app-header-menu-search-page-description-settings-organisation-details-1",
          ),
        },
        {
          title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText(
            "app-menu-submenu-settings-org-1",
          )} > ${getComponentUiText(
            "app-menu-submenu-settings-org-profile-1",
          )}`,
          url: routers.settingOrgProfile,
          descriptionInSearchModal: getComponentUiText(
            "app-header-menu-search-page-description-settings-organisation-profile-1",
          ),
        },
        {
          title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText(
            "app-menu-submenu-settings-org-1",
          )} > ${getComponentUiText(
            "app-menu-submenu-settings-org-manage-access-1",
          )}`,
          url: routers.settingOrgManageAccess,
          descriptionInSearchModal: getComponentUiText(
            "app-header-menu-search-page-description-settings-organisation-manage-access-1",
          ),
        },
      ],
    },
    {
      title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText("app-menu-submenu-settings-domains-1")}`,
      url: routers.settingDomains,
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-settings-domains-1",
      ),
    },
    {
      children: [
        {
          title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText(
            "app-menu-submenu-settings-team-1",
          )} > ${getComponentUiText(
            "app-menu-submenu-settings-team-members-1",
          )}`,
          url: routers.settingTeamMembers,
          descriptionInSearchModal: getComponentUiText(
            "app-header-menu-search-page-description-settings-team-members-1",
          ),
        },
        {
          title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText(
            "app-menu-submenu-settings-team-1",
          )} > ${getComponentUiText("app-menu-submenu-settings-team-roles-1")}`,
          url: routers.settingTeamRoles,
          descriptionInSearchModal: getComponentUiText(
            "app-header-menu-search-page-description-settings-team-roles-1",
          ),
        },
      ],
    },
    {
      title: `${getComponentUiText("app-menu-submenu-settings-1")} >
          ${getComponentUiText("app-menu-submenu-settings-subscription-1")} `,
      description: getComponentUiText(
        "app-header-menu-search-page-description-settings-subscription-1",
      ),
      url: routers.settingSubscription,
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-settings-subscription-1",
      ),
    },
  ],
  [
    {
      title: `${getComponentUiText("app-menu-submenu-learn-help-1")} >
          ${getComponentUiText("app-menu-submenu-knowledge-base-1")} `,
      url: routers.learnHelp,
      descriptionInSearchModal: getComponentUiText(
        "app-header-menu-search-page-description-help-knowledge-base-1",
      ),
    },
  ],
];

const queryPage = async () => {
  // XCU-3301: Hide some temporary hidden pages in search result
  //  Should bring back when the pages are ready
  const pages = searchKeyValue(dataQueryPage, props.searchKey);

  cached.set(TopicName.page, pages);
  onUpdateData(TopicName.page, pages);
};

const queryOrg = async () => {
  const orgs = orgList.value.filter((org: any) =>
    isIncludesSearchKey(org.name),
  );
  cached.set(TopicName.org, orgs);
  onUpdateData(TopicName.org, orgs);
};

const queryRecommend = async () => {
  let recommends = store.state.Recommend.checklistGroupMetrics;
  if (!recommends.length) {
    const fetchChecklistData = await store.dispatch(
      "Recommend/fetchChecklistData",
    );
    if (!fetchChecklistData.latestChecklist) {
      onUpdateData(TopicName.recommend, []);
      return;
    }
    await store.dispatch("Recommend/fetchChecklistGroupMetrics");
    recommends = store.state.Recommend.checklistGroupMetrics;
  }
  recommends = recommends.filter((action: any) =>
    isIncludesSearchKey(action.checklistGroupName),
  );
  cached.set(TopicName.recommend, recommends);
  onUpdateData(TopicName.recommend, recommends);
};

const queryHelp = async () => {
  const helps = [];
  cached.set(TopicName.help, helps);
  onUpdateData(TopicName.help, helps);
};

const queryMember = async () => {
  const [internal, external] = await Promise.all([
    getInternalMembersOrg(),
    getExternalMembersOrg(),
  ]);
  const members = []
    .concat(internal?.data?.data || [])
    .concat(external?.data?.data || [])
    .filter((member: any) => {
      return (
        isIncludesSearchKey(member.firstName) ||
        isIncludesSearchKey(member.lastName)
      );
    });
  cached.set(TopicName.member, members);
  onUpdateData(TopicName.member, members);
};

const queryRole = async () => {
  try {
    const res = await getOrgRoles();
    const roles = (res?.data?.data || []).filter((role: any) =>
      isIncludesSearchKey(role.roleName),
    );
    cached.set(TopicName.role, roles);
    onUpdateData(TopicName.role, roles);
  } catch (error) {
    showErrorAPI(error, Org.getOrgRoles);
  }
};

const queryAssessment = async () => {
  try {
    const res = await getAllChecklist();
    const assessments = (res?.data?.data || []).filter(
      (assessment: IAssessmentDetail) =>
        isIncludesSearchKey(assessment.checklistName),
    );
    await Promise.all(
      assessments.map(async (item: any) => {
        const res = await getDetailFromCheckListId(item.checklistId);
        item.checklistStatus = res?.data?.data?.checklistStatus || "";
        item.checklistStatusName = res?.data?.data?.checklistStatusName || "";
        item.checklistStatusId = res?.data?.data?.checklistStatusId || "";
      }),
    );
    cached.set(TopicName.assessment, assessments);
    onUpdateData(TopicName.assessment, assessments);
  } catch (error) {
    console.error(error);
  }
};

const arrayTopics: {
  id: string;
  title: string;
  queryFn: () => Promise<void>;
}[] = [
  {
    id: TopicName.page,
    title: "app-header-menu-search-topic-page-1",
    queryFn: queryPage,
  },
  {
    id: TopicName.org,
    title: "app-header-menu-search-topic-org-1",
    queryFn: queryOrg,
  },
  {
    id: TopicName.recommend,
    title: "app-header-menu-search-topic-recommended-action-1",
    queryFn: queryRecommend,
  },
  {
    id: TopicName.help,
    title: "app-header-menu-search-topic-help-topic-1",
    queryFn: queryHelp,
  },
  {
    id: TopicName.member,
    title: "app-header-menu-search-topic-member-1",
    queryFn: queryMember,
  },
  {
    id: TopicName.role,
    title: "app-header-menu-search-topic-role-1",
    queryFn: queryRole,
  },
  {
    id: TopicName.assessment,
    title: "app-header-menu-search-topic-assessment-1",
    queryFn: queryAssessment,
  },
];

const cached = new Map();
// let timer: any;
const menuData = ref<
  {
    id: string;
    title: string;
    loading: boolean;
    data: any[] | null;
    queryFn: () => Promise<void>;
  }[]
>(
  arrayTopics.map((item) => {
    return {
      ...item,
      loading: false,
      data: null,
    };
  }),
);
const orgList = computed(() => store.state.Org.orgsList);

const convertVietnameseText = (text: string) => {
  return `${text || ""}`
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[đĐ]/g, "d")
    .toLowerCase();
};

const isIncludesSearchKey = (text: string) => {
  return convertVietnameseText(text.trim()).includes(
    convertVietnameseText(props.searchKey.trim()),
  );
};

const onUpdateData = (key: string, data: any[]) => {
  cached.set(key, data || []);
  menuData.value.some((item) => {
    if (item.id === key) {
      item.loading = false;
      item.data = data;
    }
  });
};

const onSearching = async () => {
  const queries = menuData.value.filter((item) => item.loading);
  await Promise.all(queries.map((item) => item.queryFn()));
};

onMounted(() => {
  arrayTopics.forEach((item) => {
    cached.set(item.id, []);
  });
});

watch(
  () => props.searchKey,
  () => {
    arrayTopics.forEach((item) => {
      cached.set(item.id, []);
    });
    menuData.value.forEach((item) => {
      item.data = null;
    });
  },
);

watch(
  () => props.searching,
  () => {
    if (props.searching) {
      menuData.value.forEach((item) => {
        item.loading = true;
      });
      onSearching();
      // clearTimeout(timer);
      // timer = setTimeout(onSearching, 300);
    }
  },
);

watch(
  () => props.selectedFilterIds,
  () => {
    const newTopics = props.selectedFilterIds.includes(TopicName.all)
      ? arrayTopics
      : arrayTopics.filter((item) => {
          if (props.selectedFilterIds.includes(item.id)) {
            return true;
          }
          if (props.selectedFilterIds.includes(TopicName.setting)) {
            return item.id === TopicName.member || item.id === TopicName.role;
          }
        });

    menuData.value = newTopics.map((item) => {
      const data = cached.get(item.id);
      return {
        ...item,
        loading: false,
        data,
      };
    });
    if (props.searchKey) {
      onSearching();
      // clearTimeout(timer);
      // timer = setTimeout(onSearching, 300);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.searchKey || menuData.value.every((item) => !item.data))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-header-menu-search-text-empty-1")), 1),
          (listResentSearch.value.length > 0)
            ? (_openBlock(), _createBlock(ModalHoverSearchAssessment, {
                key: 0,
                "is-search-modal-assessment": false,
                "search-type-id": _unref(SEARCH_TYPE_ID).GLOB,
                "custom-class": 'tw-border-none tw-rounded-[7px] !tw-px-0',
                onUpdateCurrentValueSearch: updateCurrentValueSearchKey
              }, null, 8, ["search-type-id"]))
            : _createCommentVNode("", true)
        ]))
      : (
        _ctx.searchKey &&
        menuData.value.every(
          (item) => !item.loading && item.data && item.data.length === 0,
        )
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-header-menu-search-text-not-found-1")), 1)
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(menuData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(`global-search-menu-topic-item ${
          _ctx.selectedFilterIds.length === 1 &&
          !_ctx.selectedFilterIds.includes(_unref(TopicName).all)
            ? 'global-search-menu-topic-item-alone'
            : ''
        }`)
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(item.title)), 1)
              ]),
              (item.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (!item.data?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)("app-header-menu-search-text-not-found-1")), 1)
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.data, (data, keyItem) => {
                          return (_openBlock(), _createElementBlock("div", { key: keyItem }, [
                            (item.id === _unref(TopicName).page)
                              ? (_openBlock(), _createBlock(PageTopic, {
                                  key: 0,
                                  data: data,
                                  onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-menu')))
                                }, null, 8, ["data"]))
                              : (item.id === _unref(TopicName).org)
                                ? (_openBlock(), _createBlock(OrgTopic, {
                                    key: 1,
                                    data: data,
                                    onCloseMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-menu')))
                                  }, null, 8, ["data"]))
                                : (item.id === _unref(TopicName).recommend)
                                  ? (_openBlock(), _createBlock(RecommendTopic, {
                                      key: 2,
                                      data: data,
                                      onCloseMenu: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close-menu')))
                                    }, null, 8, ["data"]))
                                  : (item.id === _unref(TopicName).help)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createTextVNode("help")
                                      ], 64))
                                    : (item.id === _unref(TopicName).member)
                                      ? (_openBlock(), _createBlock(MemberTopic, {
                                          key: 4,
                                          data: data,
                                          onCloseMenu: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close-menu')))
                                        }, null, 8, ["data"]))
                                      : (item.id === _unref(TopicName).role)
                                        ? (_openBlock(), _createBlock(RoleTopic, {
                                            key: 5,
                                            data: data,
                                            onCloseMenu: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close-menu')))
                                          }, null, 8, ["data"]))
                                        : (_openBlock(), _createBlock(AssessmentTopic, {
                                            key: 6,
                                            data: data,
                                            onCloseMenu: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close-menu')))
                                          }, null, 8, ["data"]))
                          ]))
                        }), 128))
                  ]))
            ], 2))
          }), 128))
  ]))
}
}

})